import { render, staticRenderFns } from "./InsuranceSupervisorForm.vue?vue&type=template&id=2200c09f"
import script from "./InsuranceSupervisorForm.vue?vue&type=script&lang=ts"
export * from "./InsuranceSupervisorForm.vue?vue&type=script&lang=ts"
import style0 from "./InsuranceSupervisorForm.vue?vue&type=style&index=0&id=2200c09f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports